import React from 'react'
import LabPage from '../parts/pages/LabPage'

export default function Lab() {
  return <LabPage />
}
